module.exports = "/_next/static/media/onboard-2-shift.79407ce7.mp4";